import React from 'react';
import { Link } from 'react-router-dom';
import { ClipboardCheck, MapPin, IndianRupee, BarChart3, GraduationCap, Building2 } from 'lucide-react';
import SEOHead, { breadcrumb } from './SEOHead';
import LandingFooter from './LandingFooter';
import { POSTS } from '../content/blogPosts';
import { formatDate } from './BlogPost';
import './landing.css';

const serif = { fontFamily: '"DM Serif Display", Georgia, serif' };
const ACCENT = '#1a5fff';

// Card styling per tag; article content lives in content/blogPosts.js.
const TAG_STYLE = {
  Compliance: { icon: ClipboardCheck, bg: '#e8efff', tagBg: '#e8efff', tagColor: ACCENT },
  Attendance: { icon: MapPin, bg: '#e0f7f3', tagBg: '#e0f7f3', tagColor: '#0ea98b' },
  Payroll: { icon: IndianRupee, bg: '#fef3c7', tagBg: '#fef3c7', tagColor: '#92400e' },
  Performance: { icon: BarChart3, bg: '#fce7f3', tagBg: '#fce7f3', tagColor: '#9d174d' },
  'L&D': { icon: GraduationCap, bg: '#f0fdf4', tagBg: '#dcfce7', tagColor: '#15803d' },
  HRMS: { icon: Building2, bg: '#eff6ff', tagBg: '#e8efff', tagColor: ACCENT },
};

const Blog = () => (
  <>
    <SEOHead
      title="HR Blog — Payroll, Compliance & Attendance Guides for India | DigiHR"
      description="Practical HR guides for Indian employers: PF, ESI and PT compliance, payroll automation, GPS vs biometric attendance, performance reviews and choosing an HRMS."
      keywords="HR blog India, PF ESI compliance checklist, payroll guide India, GPS vs biometric attendance, HRMS guide"
      canonical="/blog"
      schema={breadcrumb('Blog', '/blog')}
    />

    <section style={{ padding: '60px 5% 20px', background: 'linear-gradient(160deg,#f0f4ff,#fff)' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 52 }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 12, fontWeight: 500, color: ACCENT, letterSpacing: '.08em', textTransform: 'uppercase', marginBottom: 12 }}>Resources</div>
          <h1 style={{ ...serif, fontSize: 'clamp(28px,3.5vw,42px)', lineHeight: 1.15, letterSpacing: '-.025em', color: '#0d1117', marginBottom: 16 }}>
            HR insights for <em style={{ fontStyle: 'italic', color: ACCENT }}>Indian businesses</em>
          </h1>
          <p style={{ fontSize: 17, color: '#3a3f4a', lineHeight: 1.65, maxWidth: 560, margin: '0 auto' }}>Guides, compliance updates, and best practices from the DigiHR team.</p>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 28, paddingBottom: 80 }} className="blog-grid-resp">
          {POSTS.map(({ slug, tag, title, description, updated, readMins }) => {
            const { icon: Icon, bg, tagBg, tagColor } = TAG_STYLE[tag];
            return (
              <Link key={slug} to={`/blog/${slug}`}
                style={{ display: 'block', textDecoration: 'none', background: '#fff', border: '1px solid #e4e7ed', borderRadius: 20, overflow: 'hidden', transition: 'all .2s ease' }}
                onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 4px 16px rgba(13,17,23,.08)'; e.currentTarget.style.transform = 'translateY(-3px)'; }}
                onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'none'; }}>
                <div style={{ height: 180, background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Icon size={44} color={tagColor} strokeWidth={1.5} /></div>
                <div style={{ padding: '22px 24px' }}>
                  <span style={{ display: 'inline-block', fontSize: 11, fontWeight: 600, letterSpacing: '.05em', textTransform: 'uppercase', padding: '3px 10px', borderRadius: 100, background: tagBg, color: tagColor, marginBottom: 10 }}>{tag}</span>
                  <h2 style={{ fontFamily: '"DM Sans",system-ui,sans-serif', fontSize: 16, fontWeight: 600, color: '#0d1117', marginBottom: 8, lineHeight: 1.4 }}>{title}</h2>
                  <p style={{ fontSize: 13, color: '#717888', lineHeight: 1.6, marginBottom: 14 }}>{description}</p>
                  <div style={{ fontSize: 12, color: '#717888', display: 'flex', gap: 12 }}>
                    <span>{formatDate(updated)}</span><span>{readMins} min read</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>

    <LandingFooter />

    <style>{`@media(max-width:900px){ .blog-grid-resp{ grid-template-columns:1fr !important; } }`}</style>
  </>
);

export default Blog;
